export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard/sales',
    name: 'dashboard-sales',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
  {
    path: '/dashboard/behavioral',
    name: 'dashboard-behavioral',
    component: () => import('@/views/dashboard/behavioral/ApexChart.vue'),
  },
]
